// custom-scripts.js

(function() {
    // Configuration
    const config = {
        keywords: ['tiktok', 'facebook', 'googletagmanager'],
        clarityTagId: 'gaa17om8li'
    };

    // Script Performance Optimizer
    function deferScripts() {
        document.querySelectorAll('script[src]').forEach(script => {
            if (config.keywords.some(keyword => script.src.toLowerCase().includes(keyword))) {
                script.defer = true;
                script.async = false;
                console.log('Deferred script:', script.src);
            }
        });
    }

    function lazyLoadScripts() {
        document.querySelectorAll('script[type="lazyload"]').forEach(script => {
            const newScript = document.createElement('script');
            Array.from(script.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
            newScript.removeAttribute('type');
            script.parentNode.replaceChild(newScript, script);
            console.log('Lazy loaded script:', newScript.src);
        });
    }

    function runOptimizations() {
        deferScripts();
        lazyLoadScripts();
    }

    // Klaviyo Integration
    function loadKlaviyoScript() {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
        document.head.appendChild(script);
    }

    function initKlaviyoTracking() {
        window._learnq = window._learnq || [];
        
        function addedToCart() {
            fetch(`${window.location.origin}/cart.js`)
                .then(res => res.clone().json())
                .then(data => {
                    const cart = {
                        total_price: data.total_price / 100,
                        $value: data.total_price / 100,
                        total_discount: data.total_discount,
                        original_total_price: data.original_total_price / 100,
                        items: data.items
                    };
                    if (typeof item !== 'undefined') {
                        Object.assign(cart, item);
                    }
                    if (window.klAjax) {
                        window._learnq.push(['track', 'Added to Cart', cart]);
                        window.klAjax = false;
                    }
                })
                .catch(error => console.error('Error fetching cart:', error));
        }

        // Intercept fetch requests
        const originalFetch = window.fetch;
        window.fetch = function() {
            return originalFetch.apply(this, arguments)
                .then(res => {
                    if (res.url.includes(`${window.location.origin}/cart/add.js`)) {
                        addedToCart();
                    }
                    return res;
                });
        };

        window.klAjax = true;
        document.querySelectorAll("form[action*='/cart/add'] button[type='submit']")
            .forEach(button => {
                button.addEventListener("click", () => {
                    if (window.klAjax) {
                        window._learnq.push(['track', 'Added to Cart', item]);
                        window.klAjax = false;
                    }
                });
            });
    }

    // Clarity Integration
    function loadClarityScript() {
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", config.clarityTagId);
    }

    // Custom functionality
    function customFunction() {
        console.log('Custom function executed');
    }

    // Main initialization
    function init() {
        runOptimizations();
        loadKlaviyoScript();
        loadClarityScript();
        initKlaviyoTracking();
        customFunction();

        console.log('All scripts initialized');
    }

    // Event listeners
    if ('requestIdleCallback' in window) {
        requestIdleCallback(init);
    } else {
        window.addEventListener('load', init);
    }

    // Optional Turbo support
    if (typeof Turbo !== 'undefined') {
        document.addEventListener('turbo:load', runOptimizations);
    }

    // DOM Content Loaded listener
    document.addEventListener('DOMContentLoaded', () => {
        console.log('DOM fully loaded and parsed');
    });
})();